import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI} from '@colonist/pixi'
import {UIGameAchievementBackgroundView} from '../ui_game_achievement/UIGameAchievementBackgroundView'
import {TextView} from '../../ui_canvas_engine/TextView'
import {TranslationObject} from '@colonist/i18n'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {GameFont} from '../../GameFont'
import {GameColor} from '../../GameColor'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameGoToPointAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation'
import {UIGameHoverResourceInfoView} from '../UIGameHoverResourceInfoView'
import {UIGameConstants} from '../UIGameConstants'
import {CardEnum} from '@colonist/game-states'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIGameBeginnerModeGoalView extends SectionBgView {
    private readonly initialWidth: number
    private readonly initialHeight: number
    private readonly requiredResources?: CardEnum[] | undefined
    private checkBox: UIGameAchievementBackgroundView
    private checkMark: SpriteView
    private goalText: TextView
    private goalIcon: SpriteView
    private animation: UIGameGoToPointAnimation
    private hasAnimatedUp: boolean = false
    private resourceInfo: UIGameHoverResourceInfoView

    constructor(x: number, y: number, width: number, height: number, parent: PIXI.Container, text: TranslationObject, icon?: PIXI.Texture, goalResources?: CardEnum[]) {
        super(x, y, width, height, parent)
        this.initialWidth = width
        this.initialHeight = height
        this.requiredResources = goalResources
        this.drawCheckBox()
        this.drawCheckMark()
        this.drawGoalText(text)
        this.drawIcon(icon)
    }

    private drawCheckBox() {
        const checkBoxDimension = this.initialHeight * 0.6
        const checkBoxWidth = checkBoxDimension
        const checkBoxHeight = checkBoxDimension
        this.checkBox = new UIGameAchievementBackgroundView(checkBoxWidth, checkBoxHeight)
        this.checkBox.y = (this.initialHeight - this.checkBox.height) / 2
        this.addChild(this.checkBox)
    }

    private drawCheckMark() {
        this.checkMark = new SpriteView(0, 0, this.checkBox.width, this.checkBox.height, this.checkBox, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_check))
        this.checkMark.visible = false
    }

    private drawGoalText(text: TranslationObject) {
        const x = this.checkBox.width * 1.3
        const width = this.initialWidth - this.x
        this.goalText = new TextView(text, x, 0, width, this.initialHeight, this, GameFont.Size.L, GameColor.getColor(GameColor.Color.White))
    }

    private drawIcon(icon?: PIXI.Texture) {
        if(icon == undefined) return
        const isMobile = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp

        const iconHeight = isMobile ? this.initialHeight * 0.8 : this.initialHeight * 0.5
        const iconWidth = icon.width / icon.height * iconHeight
        const iconX = this.goalText.x + this.goalText.width + this.checkBox.width * 0.3
        this.goalIcon = new SpriteView(iconX, 0, iconWidth, iconHeight, this, icon)
        this.goalIcon.centerYInParent()
    }

    completeGoal() {
        if(this.isCompleted()) return
        this.checkMark.visible = true
        this.goalText.changeStyle({fill: GameColor.getColor(GameColor.Color.GreenLink)})
        this.resourceInfo?.destroy()
    }

    animateUp() {
        if(this.hasAnimatedUp) return

        const destinationPoint = new PIXI.Point(this.x, this.y - this.initialHeight * 0.55)
        this.animation = new UIGameGoToPointAnimation(this, destinationPoint, 0.2).start()
        this.hasAnimatedUp = true
    }

    showRequiredResources(cardsInHand: CardEnum[]) {
        if(this.requiredResources == undefined) return
        const isMobile = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp

        this.resourceInfo?.destroy()
        this.resourceInfo = new UIGameHoverResourceInfoView(this.requiredResources, this, this, cardsInHand, false)
        this.resourceInfo.x = isMobile ? this.goalIcon.x + this.goalIcon.width + this.initialHeight : this.x + this.initialWidth * 0.1
        this.resourceInfo.y = this.goalText.y + (isMobile ? 0 : this.goalText.height)
        this.resourceInfo.height = isMobile ? this.initialHeight * 0.9 : this.initialHeight * 0.6
        this.resourceInfo.width = this.resourceInfo.height * this.requiredResources.length / UIGameConstants.CARD_RATIO
    }

    private isCompleted(): boolean {
        return this.checkMark.visible
    }

    destroy(options?: boolean | PIXI.IDestroyOptions | undefined): void {
        this.animation?.stop()
        this.resourceInfo?.destroy()
        super.destroy(options)
    }
}
